import { toast } from "sonner";
import { encryptLocalStorage } from "../utils/localStorage.utils";
import { getApi, imageUploadApi } from "./call.api"
import { urlApi } from "./url.api"

export const getAccessList = async () => {
    let resp = await getApi(urlApi.getStaticAccessList);
    if (resp.responseCode === 200) {
        encryptLocalStorage('all-access-list', resp.data);
    } else {
        encryptLocalStorage('all-access-list', []);
    }
};

export const getMyAccessList = async () => {
    let resp = await getApi(urlApi.getMyAccess);
    if (resp.responseCode === 200) {
        encryptLocalStorage('my-acc-list', resp.data);
    } else {
        encryptLocalStorage('my-acc-list', []);
    }
}

export const getMyProfile = async () => {
    let resp = await getApi(urlApi.getMyProfileData);
    if (resp.responseCode === 200) {
        encryptLocalStorage('profile', resp.data);
    } else {
        encryptLocalStorage('profile', {});
    }
}

export const getOrganizationList = async () => {
    let resp = await getApi(urlApi.getOrganizationList);
    if (resp.responseCode === 200) {
        encryptLocalStorage('org-list', resp.data);
    } else {
        encryptLocalStorage('org-list', []);
    }
}

export const uploadImage = async (file, folderName) => {
    const formData = new FormData();
    formData.append('image', file);
    let resp = await imageUploadApi(formData, urlApi.imageUploadApi + "?folder=" + (folderName ?? 'advy'));
    if (resp.responseCode === 200) {
        return resp.data;
    } else {
        toast.error(resp.message)
        return null;
    }
}

export const uploadFile = async (file, folderName) => {
    const formData = new FormData();
    formData.append('file', file);
    let resp = await imageUploadApi(formData, urlApi.fileUploadApi + "?folder=" + (folderName ?? 'advy'));
    if (resp.responseCode === 200) {
        return resp.data;
    } else {
        toast.error(resp.message)
        return null;
    }
}

